import { render, staticRenderFns } from "./CardOverviewPeople.vue?vue&type=template&id=02712f76&scoped=true&"
import script from "./CardOverviewPeople.vue?vue&type=script&lang=ts&"
export * from "./CardOverviewPeople.vue?vue&type=script&lang=ts&"
import style0 from "./CardOverviewPeople.vue?vue&type=style&index=0&id=02712f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02712f76",
  null
  
)

export default component.exports